"use strict";
exports.__esModule = true;
exports.IMAGE_ASPECT_RATIO_DEFAULT_VALUE = exports.IMAGE_ASPECT_RATIO = exports.ARTICLE_LIST_DISPLAY_DEFAULT_VALUE = exports.ARTICLE_LIST_DISPLAY = void 0;
var ARTICLE_LIST_DISPLAY = {
    LIST: {
        value: 'list',
        label: 'Zoznam'
    },
    LIST_WITHOUT_PICTURES: {
        value: 'list_without_pictures',
        label: 'Zoznam bez obrázkov'
    },
    TILES: {
        value: 'tiles',
        label: 'Dlaždice'
    },
    GRID: {
        value: 'grid',
        label: 'Grid'
    },
    CONTENT: {
        value: 'content',
        label: 'Zobrazovať celé články'
    },
    FULL_ROTATION: {
        label: 'Horizontálne skrolovaný zoznam článkov',
        value: 'full-rotation'
    }
};
exports.ARTICLE_LIST_DISPLAY = ARTICLE_LIST_DISPLAY;
var ARTICLE_LIST_DISPLAY_DEFAULT_VALUE = ARTICLE_LIST_DISPLAY.LIST.value;
exports.ARTICLE_LIST_DISPLAY_DEFAULT_VALUE = ARTICLE_LIST_DISPLAY_DEFAULT_VALUE;
var IMAGE_ASPECT_RATIO = {
    '4:3': {
        value: '4:3',
        label: '4:3'
    },
    '16:9': {
        value: '16:9',
        label: '16:9'
    }
};
exports.IMAGE_ASPECT_RATIO = IMAGE_ASPECT_RATIO;
var IMAGE_ASPECT_RATIO_DEFAULT_VALUE = IMAGE_ASPECT_RATIO['4:3'].value;
exports.IMAGE_ASPECT_RATIO_DEFAULT_VALUE = IMAGE_ASPECT_RATIO_DEFAULT_VALUE;
